import React from "react";

export const Box = ({className, style, title, tools, children}) => {
    return (
        <div className={`box ${className ?? ''}`} style={style}>
            {(title || tools) &&
                <div className="header">
                    <span>{title}</span>
                    {tools}
                </div>
            }
            <div className="body">
                {children}
            </div>
        </div>
    );
}

export default Box;